import React from 'react';
import PropTypes from 'prop-types';
import { format } from 'date-fns';
import Lightbox from '@cratejoy/lightbox';
import FullstoryUtil from 'fullstory_util';
import { parseUTC } from 'core/utils/dateUtils';

import {
	Content,
	FlexRow,
	FlexCol,
	SubTitle,
} from 'core/styles';
import {
	FlexContainer,
	Frame,
	MainImage,
	CalendarIcon,
	OrderNowIcon,
	ImagePlaceholder,
	HighlightText,
} from './upcomingBoxStyles';

const handleClick = (index = 0, openThumbnail) => () => {
	const trigger = openThumbnail(index);
	FullstoryUtil.sendEvent('Upcoming Box Clicked');
	trigger();
};

const UpcomingBox = ({ images, title, description, lastOrderDate, storeName }) => {
	const lastOrderFormatted = format(parseUTC(lastOrderDate), 'LLLL do');
	const lightboxSrc = images.map(img => ({ url: img.imgUrl }));
	const image = images[0];
	return (
		<FlexContainer>
			{image ? (
				<Lightbox src={lightboxSrc}>
					{({ openByIndex }) => (
						<Frame onClick={handleClick(0, openByIndex)}>
							<MainImage src={image.imgUrl} alt={image.altText || `Photo of ${storeName} current box ${title}`} title={image.altText || `Photo of ${storeName} current box ${title}`} width="324" height="324" />
							<OrderNowIcon />
						</Frame>
					)}
				</Lightbox>
			) : (
				<ImagePlaceholder />
			)}
			<FlexCol flex={1}>
				<SubTitle>{title}</SubTitle>
				<Content>{description}</Content>
				<FlexRow>
					<CalendarIcon />
					<HighlightText>
						{`Order by ${lastOrderFormatted} to get this box!`}
					</HighlightText>
				</FlexRow>
			</FlexCol>
		</FlexContainer>
	);
};

UpcomingBox.propTypes = {
	id: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number,
	]).isRequired,
	title: PropTypes.string.isRequired,
	description: PropTypes.string.isRequired,
	lastOrderDate: PropTypes.string.isRequired,
	images: PropTypes.array.isRequired,
	storeName: PropTypes.string,
};

export default UpcomingBox;
